<div id="cus_toast" [class]="'show'+ ' '+ className" *ngIf="toasterData && !toasterData.isHide">
 
    <p class="cus_toast_msg"><img *ngIf="isAlert" class="icon" [src]="warnIcon" alt=""> <span [innerHTML]="toasterData.msg"></span> <img *ngIf="toasterData.callBack" class="icon close-ico" (click)= "closeMsg()" [src]="tosterCloseIcon" alt=""></p>

</div>